// extracted by css-extract-rspack-plugin
export default {"cls1":"FileUpload-cls1_AWK","cls2":"FileUpload-cls2_a_V FileUpload-cls1_AWK"};